// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner--39bhV","homeIcon":"homeIcon--2EfvI","center":"center--2L1kQ","right":"right--2iK5l","save":"save--iBK7f","resultFigure":"resultFigure--2GLrE"};